import React, { useState } from 'react'
import { Typography, Form, Input, Button, Row, Space, Flex } from 'antd';
import { PasswordRequirements } from '../../UI/PasswordRequirements.component';
import { EyeInvisibleOutlined, EyeTwoTone, CheckCircleFilled } from '@ant-design/icons';
import { updateUser, updatePassword } from '../../../services/UserService';
import { isValidPassword } from '../../../Validation';
import { useMessage } from '../../UI/MessageProvider';

const { Title, Text } = Typography; 

export const ChangePasswordForm = ({account, title, showTitle, btnAlign, ...props}) => {

    const [form] = Form.useForm();
    const message = useMessage();
    
    const [successMessage, setSuccessMessage] = useState(false);
    const [displayPwReq, setDisplayPwReq] = useState(false);

    const [newPassword, setNewPassword] = useState('');

    const handleChangePassword = (data) => {
        
        Object.assign(data, { userID: account.id, username: account.username})
        updatePassword(data).then( function (response) {
            if(response.success) {
                if(window.location.pathname !== '/app/account'){
                    setSuccessMessage(true);
                    setTimeout(() => message.open({
                        type: 'loading', 
                        content: 'Redirecting...', 
                        duration: 0
                    }), 2000);
                    setTimeout(() => window.location.reload(), 3000);
                } else {
                    message.success("You've successfully changed your password!");
                }

                form.resetFields();
                
                if( response.logout ) {
                    // logout()
                }
                
                return;
            }

            message.error((response.message) ? response.message : response.error, 4);
        })
    }

    const checkPasswordRequirements = () => {
        return (
            <div style={{backgroundColor: 'var(--gray-3)', padding: 10, marginTop: -5, marginBottom: 10}}>
                <p><strong>Password Requirements:</strong></p> 
                <PasswordRequirements password={newPassword}/>
            </div>
        );
    }

    return(
        <>
            <div className="account__change-password" {...props}>
                <div className='account__edit-form-container'>
                    {showTitle &&
                        <>
                            <Title level={5}>{title || 'Change Password'}</Title>
                        </>
                    }
                    
                    <Form 
                        form={form}
                        name="account-change-password-form" 
                        layout="vertical"
                        onFinish={handleChangePassword}
                        onValuesChange={() => setDisplayPwReq(true)}
                    >
                        <Form.Item
                            name="currentPassword"
                            label="Current Password:"
                            rules={[{ required: true, message: "Required"}]}
                            >
                            <Input.Password allowClear iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                        </Form.Item>
                        
                        <Form.Item
                            name="password"
                            label="New Password:"
                            hasFeedback
                            rules={[
                                {
                                    required: true,
                                    message: 'Required'
                                },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        setNewPassword(value);
                                        if (value && isValidPassword(value)){
                                            return Promise.resolve();
                                        } 
                                        return Promise.reject();
                                        },
                                    }),
                                ]}
                            >
                            <Input.Password allowClear showCount iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                        </Form.Item>
                        
                        { (displayPwReq && (newPassword && !isValidPassword(newPassword))) ? checkPasswordRequirements() : null }

                        <Form.Item
                            name="confirm-password"
                            label="Confirm New Password:"
                            dependencies={['account-new-password']}
                            hasFeedback
                            rules={[
                                { 
                                    required: true, 
                                    message: "Required"
                                }, 
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if(!value || getFieldValue('password') === value){
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error('The password that you just entered does not match.'))
                                    }
                                }),
                            ]}
                            >
                            <Input.Password allowClear iconRender={visible => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)} />
                        </Form.Item>
                        
                        { props?.backToLogin ? 
                            <Flex vertical gap='middle'>
                                <Button type="primary" block htmlType="submit" className='btn-block'>Change Password</Button>
                                <Button type='link' onClick={() => window.location.reload()}>Log Out</Button>
                            </Flex>
                            :
                            <Row justify={btnAlign}>
                                <Space>
                                    <Button type="primary" htmlType="submit">Change Password</Button>
                                    <Button onClick={() => {
                                        form.resetFields();
                                        setDisplayPwReq(false)
                                    }}>Cancel</Button>
                                </Space>
                            </Row>
                        }

                        { successMessage &&
                            <Row justify='center' style={{marginBottom: 20}}>
                                <Space align='start'>
                                    <CheckCircleFilled style={{color: 'var(--success-color)'}} />
                                    <Text type='success'>You've successfully changed your password!<br/>You'll be redirected to the login page shortly...</Text>
                                </Space>
                            </Row>
                        }
                    </Form>
                </div>
            </div>
        </>
    )
};

ChangePasswordForm.defaultProps = {
    showTitle: true,
    btnAlign: 'start',
}